var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1448_260306",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1448_260306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 18.9429H8.625V12.7714H15.375V18.9429H18.75V9.68571L12 5.05714L5.25 9.68571V18.9429ZM5.25 21C4.63125 21 4.10156 20.7986 3.66094 20.3957C3.22031 19.9929 3 19.5086 3 18.9429V9.68571C3 9.36 3.07969 9.05143 3.23906 8.76C3.39844 8.46857 3.61875 8.22857 3.9 8.04L10.65 3.41143C10.8563 3.27429 11.0719 3.17143 11.2969 3.10286C11.5219 3.03429 11.7562 3 12 3C12.2438 3 12.4781 3.03429 12.7031 3.10286C12.9281 3.17143 13.1437 3.27429 13.35 3.41143L20.1 8.04C20.3812 8.22857 20.6016 8.46857 20.7609 8.76C20.9203 9.05143 21 9.36 21 9.68571V18.9429C21 19.5086 20.7797 19.9929 20.3391 20.3957C19.8984 20.7986 19.3688 21 18.75 21H13.125V14.8286H10.875V21H5.25Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeOff);
export default __webpack_public_path__ + "static/media/icon-home-off.d6d6e2aeb694ff1b64df5bccaa10bca6.svg";
export { ForwardRef as ReactComponent };